// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__uwomt","footer":"Form_footer__1y_AN"};